import React, { useEffect, useState } from "react";
import { Checkbox } from "antd";
import arrow from "../../../assets/img/icons/arrow-left-green.svg";
import Button from "../../shared/Button";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import { useParams } from "react-router-dom";
const CreateStep6part2 = ({ prevStep, nextStep }) => {
  const { updatePlaceDetail, createInfoData,apiUpdateResideces ,setIsEditPlaceCompleter} = useCreatePlace();
  const [elderly_and_minors, setelderly_and_minors] = useState(
    createInfoData.stepEight.elderly_and_minors
  );
  const [physical_disabilities, setphysical_disabilities] = useState(
    createInfoData.stepEight.physical_disabilities
  );
  const [disinfected, setdisinfected] = useState(
    createInfoData.stepEight.disinfected
  );
  const [long_term, setlong_term] = useState(
    createInfoData.stepEight.long_term
  );
  const [have_janitor, sethave_janitor] = useState(
    createInfoData.stepEight.have_janitor
  );
  const [economical, seteconomical] = useState(
    createInfoData.stepEight.economical
  );
  console.log(createInfoData)
  const [luxury, setluxury] = useState(createInfoData.stepEight.luxury);
console.log("luxury",luxury)


  const onChangeelderly_and_minors = e => {
    setelderly_and_minors(e.target.checked);
  };

  const onChangephysical_disabilities = e => {
    setphysical_disabilities(e.target.checked);
  };
  const onChangedisinfected = e => {
    setdisinfected(e.target.checked);
  };
  const onChangelong_term = e => {
    setlong_term(e.target.checked);
  };
  const onChangehave_janitor = e => {
    sethave_janitor(e.target.checked);
  };
  const onChangeeconomical = e => {
    seteconomical(e.target.checked);
  };
  const onChangeluxury = e => {
    setluxury(e.target.checked);
  };

  const gotonext = () => {
    updatePlaceDetail("stepEight", {
      elderly_and_minors: elderly_and_minors,
      physical_disabilities: physical_disabilities,
      disinfected: disinfected,
      long_term: long_term,
      have_janitor: have_janitor,
      economical: economical,
      luxury: luxury
    });
    nextStep();
  };
  const [feature, setfeature] = useState();
  const onChangefeature = e => {
    console.log("radio checked", e.target.value);
    setfeature(e.target.value);
  };
  const {id}=useParams()
  const update = (data) => {
    updatePlaceDetail("stepEight", {
      elderly_and_minors: elderly_and_minors,
      physical_disabilities: physical_disabilities,
      disinfected: disinfected,
      long_term: long_term,
      have_janitor: have_janitor,
      economical: economical,
      luxury: luxury
    });
       setIsEditPlaceCompleter(true);
    
    
  };
  return (
    <div className="createsteps">
      {" "}<h2>خدمات خاص</h2>
      <p className="w-[100%] ">
        برای پذیرش مهمانان خاص، لازم است که اقامتگاه شما دارای یک سری شرایط خاص
        باشد. لطفا قبل از انتخاب گزینه‌های زیر، این شرایط را با دقت مطالعه
        نمایید.
      </p>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        امکانات رفاهی
      </h4>
      <p className="w-[100%] ">
        شرایط پذیرش را با دقت مطالعه کنید و تنها در صورتی که اقامتگاه‌تان مشمول
        آن می‌شود، گزینه زیر را انتخاب کنید.
      </p>
      <div className="primary-checkbox">
        <Checkbox
          value={elderly_and_minors}
          onChange={onChangeelderly_and_minors}
          defaultChecked={elderly_and_minors}
        >
          این اقامتگاه مناسب پذیرش کودک و سالمند می باشد .
        </Checkbox>
      </div>
      <Button varient="outlined" className="mt-[20px]">
        <div className="flex gap-[11px]">
          <div>شرایط پذیرش</div>
          <img src={arrow} />
        </div>
      </Button>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        پذیرش مهمانان دارای ناتوانی جسمی
      </h4>
      <p className="w-[100%] ">
        شرایط پذیرش را با دقت مطالعه کنید و تنها در صورتی که اقامتگاه‌تان مشمول
        آن می‌شود، گزینه زیر را انتخاب کنید.
      </p>
      <div className="primary-checkbox">
        <Checkbox
          onChange={onChangephysical_disabilities}
          value={physical_disabilities}
          defaultChecked={physical_disabilities}

        >
          این اقامتگاه مناسب مهمان های دارای ناتوانی جسمی می باشد .
        </Checkbox>
      </div>
      <Button varient="outlined" className="mt-[20px]">
        <div className="flex gap-[11px]">
          <div>شرایط پذیرش</div>
          <img src={arrow} />
        </div>
      </Button>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        اقامتگاه ضد عفونی شده
      </h4>
      <p className="w-[100%] ">
        اقامتگاهی که مطابق با پروتکل های بهداشتی ضد عفونی و نظافت شده است{" "}
      </p>
      <div className="primary-checkbox">
        <Checkbox onChange={onChangedisinfected} value={disinfected}  defaultChecked={disinfected} >
          این اقامتگاه ضد عفونی می باشد .
        </Checkbox>
      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        امکان رزرو بلد مدت
      </h4>
      <p className="w-[100%] ">
        اقامتگاهی که مطابق با پروتکل های بهداشتی ضد عفونی و نظافت شده است{" "}
      </p>
      <div className="primary-checkbox">
        <Checkbox value={long_term} onChange={onChangelong_term} defaultChecked={long_term} >
          اقامتگاهی که مطابق با پروتکل های بهداشتی ضد عفونی و نظافت شده است
        </Checkbox>
      </div>
      <div className="createsteps-choosingbox mt-[82px]">
        <h6 className="mb-[8px] text-[#292D32] text-[18px] font-[700]">
          {" "}خدمات یا ویژگی های خاص
        </h6>
        <div className="createsteps-grid-4">
          <Checkbox value={have_janitor}  defaultChecked={have_janitor} onChange={onChangehave_janitor}>
            دارای سرایدار / نگهبان
          </Checkbox>
          <Checkbox value={economical}  defaultChecked={economical} onChange={onChangeeconomical}>
            اقتصادی می باشد
          </Checkbox>
          <Checkbox value={luxury} defaultChecked={luxury}  onChange={onChangeluxury}>
            لوکس و مجلل است
          </Checkbox>
        </div>
      </div>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
      {id && <Button varient="primary" onClick={()=>update()}> 
                بروزرسانی اقامتگاه
              </Button>}
        <Button
          varient="gray"
          onClick={() => {
            prevStep();
          }}
        >
          مرحله قبلی
        </Button>

        <Button varient="primary" onClick={() => gotonext()}>
          مرحله بعدی
        </Button>
      </div>
    </div>
  );
};

export default CreateStep6part2;
